import { IonSpinner } from "@ionic/react";
import { memo, Suspense } from "react";

interface LazyWrapperProps {
  children: React.ReactNode;
}

const PageLoader = () => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-violet-950">
    <IonSpinner name="crescent" className="h-12 w-12 text-white" />
    <p className="ml-2 text-white">&nbsp;</p>
  </div>
);

export const LazyWrapper = memo(function LazyWrapper({
  children,
}: LazyWrapperProps) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
});
